var styles = {"loading":"LoadingIcon-module_loading__0HL5U","spinner-border":"LoadingIcon-module_spinner-border__ti71I"};

export { styles as default };
//# sourceMappingURL=LoadingIcon.module.scss.js.map
